import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IOwnTeam, PaginateResponse } from '@tacliatech/types';

@Injectable({
  providedIn: 'root',
})
export class OwnTeamSearchService {
  constructor(private http: HttpClient) {}

  search(query: { [key: string]: any } = {}) {
    const params = new HttpParams({
      fromObject: {
        ...query,
      },
    });

    return this.http.get<PaginateResponse<IOwnTeam[]>>(
      `:API_URL/search/own-teams`,
      {
        params,
      }
    );
  }
}
